<template>
  <div>
    <List>
      <show-cell
        v-for="(message, index) in messages"
        :key="index"
        :message="message"
        :statusRead="statusReads[index]"
        />
    </List>
  </div>
</template>

<script>
import List from '@/components/List'
import ShowCell from '@/components/Message/ShowCell'
import Parse from 'parse'

export default {
  components: {
    List,
    ShowCell
  },

  data () {
    return {
      messages: [],
      statusReads: []
    }
  },

  created: async function () {
    let query = new Parse.Query('Message')
    query.include('status')
    query.descending('createdAt')
    this.messages = await query.find()
    this.statusReads = this.messages.map((m) => {
      return m.get('status').get('read')
    })
  }
}
</script>
